import React from 'react';
import { useRouter } from 'next/router';
import { signOut } from 'next-auth/react';
import { useAccountAccess } from 'context/accountAccessProvider';
import { buildChoosePlanPath } from 'utils/choosePlanPath';
import ChoosePlanGateModal from './ChoosePlanGateModal';

// The screens the lock must never cover. Blocking these would leave the
// merchant no way to pay, which is the one thing the lock is asking them to do.
const UNLOCKED_ROUTES = ['/settings', '/billing', '/login', '/logout', '/auth'];

function isUnlockedRoute(pathname) {
  return UNLOCKED_ROUTES.some((route) => pathname === route || pathname.startsWith(`${route}/`));
}

/**
 * Locks the app when the account is off and only a plan brings it back.
 *
 * Rendered beside the page rather than around it: the modal's backdrop covers
 * the app, so the merchant still sees their store behind it — the point is that
 * the data is still there — while nothing behind it can be used.
 *
 * Renders nothing while the status is still loading, so a slow request shows
 * the app rather than a lock that might be wrong.
 */
const AccountAccessGate = () => {
  const router = useRouter();
  const { isLocked, canChoosePlan, isLoading } = useAccountAccess();

  if (isLoading || !isLocked) return null;
  if (isUnlockedRoute(router.pathname)) return null;

  const goToChoosePlan = () => {
    const { userId, businessAccountId } = router.query;
    router.push(buildChoosePlanPath({ userId, businessAccountId }));
  };

  return (
    <ChoosePlanGateModal
      canChoosePlan={canChoosePlan}
      onChoosePlan={goToChoosePlan}
      onLogout={() => signOut()}
    />
  );
};

export default AccountAccessGate;
